import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function AddEditCollaborators() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isEdit = Boolean(id);

  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    if (isEdit && location.state?.logoUrl) {
      setLogoUrl(location.state.logoUrl);
    }
  }, [isEdit, location.state]);

  const handleSubmit = async () => {
    if (!logoUrl) return alert("Image URL required");

    try {
      if (isEdit) {
        await axios.put(
          `https://api.livestockify.com/api/admin/collaborators/${id}`,
          { logoUrl }
        );
      } else {
        await axios.post(
          "https://api.livestockify.com/api/admin/collaborators",
          { logoUrl }
        );
      }

      navigate("/uploads/collaborators");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 md:pl-14 pl-4">
        <h1 className="text-lg font-semibold text-green-700 mb-8">
          {isEdit ? "Edit Collaborators Image" : "Add Collaborators Image"}
        </h1>

        <div className="flex justify-center">
          <div className="w-full max-w-3xl">
          <div className="grid grid-cols-1 sm:grid-cols-[150px_1fr] gap-4 sm:gap-6 mb-10 items-center">
  <label className="text-sm text-left sm:text-right">Image URL</label>

  <input
    value={logoUrl}
    onChange={(e) => setLogoUrl(e.target.value)}
    className="border rounded-md px-3 py-2 text-sm w-full"
    placeholder="Enter Image URL"
  />
</div>

            <div className="flex justify-end gap-4">
              <button
                onClick={() => navigate("/uploads/collaborators")}
                className="border px-6 py-2 rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-6 py-2 rounded-md text-sm"
              >
                {isEdit ? "Update" : "Upload"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
